module.exports = __webpack_public_path__ + "img/avatar.198271a8.png";